export default __webpack_public_path__ + "static/media/ambio-icon.b2e2d1d9.svg";